export default "__VITE_ASSET__DNlqgUJE__"